export const GET_NZ_VARIABLES = 'GET_NZ_VARIABLES'
export const RESET_VARIABLES = 'RESET_VARIABLES'
export const SET_THEME_COLORS = 'SET_THEME_COLORS'
export const SET_BROWSER_TAB = 'SET_BROWSER_TAB'